import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center">
      <div className="text-center px-4">
        <div className="w-20 h-20 flex items-center justify-center rounded-2xl bg-background-100 text-foreground-400 mx-auto mb-6">
          <i className="ri-error-warning-line text-3xl"></i>
        </div>
        <h1 className="font-heading text-4xl md:text-6xl font-bold text-foreground-950 mb-3">404</h1>
        <p className="text-base text-foreground-500 mb-2">Strona nie została znaleziona</p>
        <p className="text-sm text-foreground-400 mb-8">Przepraszamy, ale strona której szukasz nie istnieje.</p>
        <Link
          to="/"
          className="btn-primary inline-flex px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 rounded-md transition-all duration-200"
        >
          <i className="ri-arrow-left-line mr-2"></i>
          Powrót do strony głównej
        </Link>
      </div>
    </div>
  );
}